import { Shimmer } from '@components';

import { Container } from './CustomFieldDetails.styles';

const Row = () => {
  return (
    <Shimmer
      style={{ height: 48, width: '100%', borderRadius: 8 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

const CustomFieldDetailsLoading = () => {
  return (
    <Container>
      <Row />
      <div style={{ height: 16 }} />
      <Row />
      <div style={{ height: 16 }} />
      <Row />
      <div style={{ height: 16 }} />
      <Row />
    </Container>
  );
};

export { CustomFieldDetailsLoading };
